import React from "react";
import { useDispatch } from "react-redux";
import { MainModal } from "../../../../components/modal/MainModal";
import { deleteUser } from "../redux/usersSagas";

export const Delete = ({ isOpen, onClose, selected: { id, name } = {} }) => {
  const dispatch = useDispatch();

  const primaryBtnHandler = () => {
    dispatch(deleteUser({ id }));
    onClose();
  };

  return (
    <MainModal
      parentSelector=".users"
      isOpen={isOpen}
      onClose={onClose}
      headerText="Delete"
      headerCloseHandler={onClose}
      width={300}
      height="auto"
      primaryButtonText="Delete"
      primaryBtnHandler={primaryBtnHandler}
      primaryButtonClass="critical"
      secondaryBtnText="Cancel"
      secondaryBtnHandler={onClose}
      containerClassName="dialog"
    >
      Are you sure to delete <span className="text-bold">{name}</span> user?
    </MainModal>
  );
};
